import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
import { CheckIcon } from 'lucide-react';
export function Deliverables() {
  const items = [{
    title: 'El Libro Digital Completo',
    desc: 'Cocina Anti-Inflamatoria (Edición Supermercado).'
  }, {
    title: 'Lista de Compras',
    desc: '"Entra y Sal de la Tienda en 20 Minutos".'
  }, {
    title: 'El Protocolo de Emergencia',
    desc: 'De 3 Días para apagar brotes de dolor agudo.'
  }, {
    title: 'Guía Visual',
    desc: 'Cómo leer etiquetas sin usar una lupa por una hora.'
  }, {
    title: 'Calendario de 14 días',
    desc: 'Qué comer desde el desayuno hasta la cena para ver resultados.'
  }];
  return <AnimatedSection className="py-24 px-6 max-w-5xl mx-auto" data-id="element-31">
      <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-32">
        Lo que recibirás
      </h2>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-33">
        {items.map((item, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-md border border-brand-green/10 flex flex-col items-center text-center" data-id="element-34">
            <div className="bg-brand-lightGreen p-4 rounded-full mb-6" data-id="element-35">
              <CheckIcon className="w-8 h-8 text-brand-green" data-id="element-36" />
            </div>
            <h3 className="text-xl font-bold mb-2 text-brand-green" data-id="element-37">
              {item.title}
            </h3>
            <p className="text-brand-gray/80" data-id="element-38">{item.desc}</p>
          </div>)}
      </div>
    </AnimatedSection>;
}